import React, { useState } from "react";
import styles from "./EventSeatingMap.module.css";
import SeatingComponent from "@components/SeatingMap/Seating";
import { useRouter } from "next/navigation";

export default function EventSeatingMap({
  seatingDataMap,
  user,
  groups,
  tickets,
  utm_source,
  sizeScreen,
  openSeatingMap,
  setOpenSeatingMap,
  handleOpenCloseSeating,
  event,
  handleOpenPolicy
}) {
  console.log(utm_source);
  const { image, seatingMapID, seatingTickets, eventID } = seatingDataMap;
  const router = useRouter();

  console.log(tickets.length, groups.length);
  return (
    <>
      <div onClick={handleOpenCloseSeating}>
        {(tickets?.length > 0 || groups?.length > 0) && (
          <p className={styles.or}>
            <hr />
            <h2>OR</h2> <hr />
          </p>
        )}
        <h2>Buy On Map</h2>

        <div className={styles.preview}>
          <p className={styles.text}>Buy on map</p>
          <img
            className={styles.click}
            src="/assets/images/mouseClick.svg"
            alt=""
          />
          <div className={styles.overlay}></div>
          <img className={styles.map} src={image} alt="" />
        </div>
      </div>
      {openSeatingMap && (
        <div className={styles.seatingOverlay}>
          <SeatingComponent
            seatingMapID={seatingMapID}
            handleOpenCloseSeating={handleOpenCloseSeating}
            seatingTickets={seatingTickets}
            eventID={eventID}
            app={false}
            utm_source={utm_source}
            sizeScreen={sizeScreen}
            event={event}
            handleOpenPolicy={handleOpenPolicy}
          />
        </div>
      )}
    </>
  );
}
